import React from 'react';

import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import BodyRegular from 'components/Typography/BodyRegular';
import useThemeController from 'hooks/theme/useThemeController';

import './NotFound.scss';

const SUPPORT_EMAIL_HREF = 'mailto:desenvolvimento@ampereconsultoria.com.br';

export default function NotFound() {
  useThemeController({ anyRoute: true });
  const navigate = useNavigate();

  return (
    <Container className="not-found-page">
      <div className="not-found-page__wrapper">
        <div className="not-found-page__icon" aria-hidden="true">
          <Icon iconType="search" size="large" />
        </div>

        <h1 className="title-bold not-found-page__title">Página não encontrada</h1>
        <SubtitleRegular>
          A página que você tentou acessar não existe ou foi movida.
        </SubtitleRegular>
        <BodyRegular>
          Verifique o endereço na barra de navegação ou, se acredita que ela deveria existir,
          {' '}
          <a href={SUPPORT_EMAIL_HREF} className="not-found-page__support-link">
            fale com o nosso suporte
          </a>
          .
        </BodyRegular>

        <div className="not-found-page__actions">
          <Button icon="home" onClick={() => navigate('/home')}>
            Ir para a home
          </Button>
          <button
            type="button"
            className="not-found-page__back-link"
            onClick={() => navigate(-1)}
          >
            Voltar à página anterior
          </button>
        </div>
      </div>
    </Container>
  );
}
